/* unplugin-vue-components disabled */import { render } from "./reasoning-list.vue?vue&type=template&id=1f2359a4&scoped=true"
import script from "./reasoning-list.vue?vue&type=script&lang=js"
export * from "./reasoning-list.vue?vue&type=script&lang=js"

import "./reasoning-list.vue?vue&type=style&index=0&id=1f2359a4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2359a4"],['__file',"src/components/ai-chat-v2/ai-assistant/research/reasoning-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f2359a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f2359a4', __exports__)) {
    api.reload('1f2359a4', __exports__)
  }
  
  module.hot.accept("./reasoning-list.vue?vue&type=template&id=1f2359a4&scoped=true", () => {
    api.rerender('1f2359a4', render)
  })

}


export default __exports__